import React from 'react'

import CommentFormDialog from '../CommentFormDialog'
import {
  ApartmentChecklistFragmentFragment,
  useInsertApartmentChecklistCommentMutation
} from 'api/generated'
import { useUser } from 'context/auth/user'

export type ApartmentChecklistCommentFormDialogProps = {
  apartmentChecklist?: ApartmentChecklistFragmentFragment
  openDialog: boolean
  onCancel: () => void
}

const ApartmentChecklistCommentFormDialog: React.FC<
  ApartmentChecklistCommentFormDialogProps
> = ({
  apartmentChecklist,
  openDialog,
  onCancel
}: ApartmentChecklistCommentFormDialogProps) => {
  const { dbUser } = useUser()
  const [insertApartmentChecklistComment, { loading, error }] =
    useInsertApartmentChecklistCommentMutation()

  return (
    <CommentFormDialog
      loading={loading}
      error={error}
      openDialog={openDialog}
      onCancel={onCancel}
      onSubmit={(data, onCompletedCallback) => {
        insertApartmentChecklistComment({
          variables: {
            object: {
              apartment_checklist_id: apartmentChecklist?.id,
              user_id: dbUser?.id,
              comment: data?.comment,
              files: {
                data: data?.files?.map(file => {
                  return {
                    path: file?.value,
                    folder: 'apartment-checklist'
                  }
                })
              }
            }
          },
          onCompleted: data => {
            if (data?.apartmentChecklistComment) {
              onCompletedCallback?.()
            }
          }
        })
      }}
    />
  )
}

export default ApartmentChecklistCommentFormDialog
